var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, flatMap, map } from 'rxjs/operators';
import { PolicyService } from '@app/core';
import { PolicyStatementActionTypes, CompleteLoadPolicyStatementServicesAction, FailLoadPolicyStatementServicesAction, CompleteLoadPolicyStatementResourceActionsAction, FailLoadPolicyStatementResourceActionsAction } from './policy-statement.actions';
var PolicyStatementEffects = /** @class */ (function () {
    function PolicyStatementEffects(actions$, policyService) {
        var _this = this;
        this.actions$ = actions$;
        this.policyService = policyService;
        this.requestOnLoadStatementServices$ = this.actions$.pipe(ofType(PolicyStatementActionTypes.SERVICES_LOADING), flatMap(function (action) { return _this.requestServices(); }));
        this.requestOnLoadStatementResourceActions$ = this.actions$.pipe(ofType(PolicyStatementActionTypes.RESOURCE_ACTIONS_LOADING), flatMap(function (action) { return _this.requestResourceActions(action.payload); }));
    }
    PolicyStatementEffects.prototype.requestServices = function () {
        return this.policyService.getServices().pipe(map(function (services) { return new CompleteLoadPolicyStatementServicesAction({ services: services }); }), catchError(function (_) { return of(new FailLoadPolicyStatementServicesAction()); }));
    };
    PolicyStatementEffects.prototype.requestResourceActions = function (_a) {
        var serviceId = _a.serviceId;
        return this.policyService.getResourceActions(serviceId).pipe(map(function (resourceActions) { return new CompleteLoadPolicyStatementResourceActionsAction({ serviceId: serviceId, resourceActions: resourceActions }); }), catchError(function (_) { return of(new FailLoadPolicyStatementResourceActionsAction({ serviceId: serviceId })); }));
    };
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], PolicyStatementEffects.prototype, "requestOnLoadStatementServices$", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], PolicyStatementEffects.prototype, "requestOnLoadStatementResourceActions$", void 0);
    return PolicyStatementEffects;
}());
export { PolicyStatementEffects };



// WEBPACK FOOTER //
// ./src/app/access-management/state/policy-statement.effects.ts.pre-build-optimizer.js